var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gradeApplication" }, [
    _c("div", { staticClass: "cont-box" }, [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("Title", { attrs: { text: "成绩申请", isShowBack: true } }),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "search",
                  staticClass: "search-form",
                  attrs: {
                    slot: "search",
                    inline: true,
                    model: _vm.condition,
                    rules: _vm.searchRules,
                    "label-width": "80px",
                  },
                  slot: "search",
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div"),
                      _vm.isShowGradeApplicationBtn
                        ? _c("div", [
                            _c("div", { staticClass: "btn-box" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: _vm.gradeApplicationClick,
                                          },
                                        },
                                        [_vm._v("成绩申请")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.list,
                    headerRowClassName: "uni-primary-table-header",
                    stripe: "",
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "paper_plan_title",
                      align: "center",
                      label: "计划",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "paper_titlle",
                      align: "center",
                      label: "论文标题",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "qa_content",
                      align: "center",
                      label: "问答内容",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "link-btn",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.QAClick(row)
                                  },
                                },
                              },
                              [_vm._v("查看问答")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "check_status_title",
                      align: "center",
                      label: "评分状态",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "check_remark",
                      align: "center",
                      label: "审核备注",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "final_score",
                      align: "center",
                      label: "最终得分",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return row.check_status == 0
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "link-btn",
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.revokeScore(row)
                                        },
                                      },
                                    },
                                    [_vm._v("撤销")]
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "applyFormPop",
              attrs: {
                title: "成绩申请",
                visible: _vm.isShowApplyFormPop,
                width: "40%",
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isShowApplyFormPop = $event
                },
                close: _vm.applyFormPopClose,
              },
            },
            [
              _c("div", { staticClass: "dialog" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        ref: "applyForm",
                        attrs: {
                          model: _vm.applyFormData,
                          rules: _vm.applyFormRules,
                          "label-width": "160px",
                        },
                      },
                      [
                        _c(
                          "el-tabs",
                          {
                            on: { "tab-click": _vm.tabHandle },
                            model: {
                              value: _vm.activeName,
                              callback: function ($$v) {
                                _vm.activeName = $$v
                              },
                              expression: "activeName",
                            },
                          },
                          [
                            _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "第一步",
                                  name: "1",
                                  disabled: true,
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "毕业设计(论文)题目",
                                      prop: "paper_titlle",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入毕业设计(论文)题目",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.applyFormData.paper_titlle,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.applyFormData,
                                            "paper_titlle",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "applyFormData.paper_titlle",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "教师提问1",
                                      prop: "question1",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入教师提问1",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.applyFormData.question1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.applyFormData,
                                            "question1",
                                            $$v
                                          )
                                        },
                                        expression: "applyFormData.question1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "学生回答1",
                                      prop: "answer1",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入学生回答1",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.applyFormData.answer1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.applyFormData,
                                            "answer1",
                                            $$v
                                          )
                                        },
                                        expression: "applyFormData.answer1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "教师提问2",
                                      prop: "question2",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入教师提问2",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.applyFormData.question2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.applyFormData,
                                            "question2",
                                            $$v
                                          )
                                        },
                                        expression: "applyFormData.question2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "学生回答2",
                                      prop: "answer2",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入学生回答2",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.applyFormData.answer2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.applyFormData,
                                            "answer2",
                                            $$v
                                          )
                                        },
                                        expression: "applyFormData.answer2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "教师提问3",
                                      prop: "question3",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入教师提问3",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.applyFormData.question3,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.applyFormData,
                                            "question3",
                                            $$v
                                          )
                                        },
                                        expression: "applyFormData.question3",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "学生回答3",
                                      prop: "answer3",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入学生回答3",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.applyFormData.answer3,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.applyFormData,
                                            "answer3",
                                            $$v
                                          )
                                        },
                                        expression: "applyFormData.answer3",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "第二步",
                                  name: "2",
                                  disabled: true,
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "最终论文资料:",
                                      prop: "files_url2",
                                    },
                                  },
                                  [
                                    _c("FalConUpload", {
                                      ref: "uploadFile1",
                                      attrs: {
                                        listStyle: "text",
                                        accept: ".pdf",
                                        isFile: true,
                                        isAccept: false,
                                      },
                                      on: {
                                        handleRemove: function ($event) {
                                          return _vm.handleRemoveFile(
                                            $event,
                                            "files_url2"
                                          )
                                        },
                                        handleChange: function ($event) {
                                          return _vm.handleChangeFile(
                                            $event,
                                            "files_url2",
                                            "1论文",
                                            "uploadFile1",
                                            "applyForm"
                                          )
                                        },
                                      },
                                    }),
                                    _c("div", { staticClass: "tips" }, [
                                      _vm._v(
                                        "说明：PDF格式文件，文件名为：1论文学号姓名.pdf"
                                      ),
                                      _c("br"),
                                      _vm._v("例如：1论文012201161020张三.pdf"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "开题报告:",
                                      prop: "report_files2",
                                    },
                                  },
                                  [
                                    _c("FalConUpload", {
                                      ref: "uploadFile3",
                                      attrs: {
                                        listStyle: "text",
                                        accept: ".pdf",
                                        isFile: true,
                                        isAccept: false,
                                      },
                                      on: {
                                        handleRemove: function ($event) {
                                          return _vm.handleRemoveFile(
                                            $event,
                                            "report_files2"
                                          )
                                        },
                                        handleChange: function ($event) {
                                          return _vm.handleChangeFile(
                                            $event,
                                            "report_files2",
                                            "2开题",
                                            "uploadFile3",
                                            "applyForm"
                                          )
                                        },
                                      },
                                    }),
                                    _c("div", { staticClass: "tips" }, [
                                      _vm._v(
                                        "说明：在系统中下载。PDF格式文件，文件名为：2开题学号姓名.pdf"
                                      ),
                                      _c("br"),
                                      _vm._v("例如：2开题012201161020张三.pdf"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "查重报告:",
                                      prop: "duplicate_files2",
                                    },
                                  },
                                  [
                                    _c("FalConUpload", {
                                      ref: "uploadFile4",
                                      attrs: {
                                        listStyle: "text",
                                        accept: ".pdf",
                                        isFile: true,
                                        isAccept: false,
                                      },
                                      on: {
                                        handleRemove: function ($event) {
                                          return _vm.handleRemoveFile(
                                            $event,
                                            "duplicate_files2"
                                          )
                                        },
                                        handleChange: function ($event) {
                                          return _vm.handleChangeFile(
                                            $event,
                                            "duplicate_files2",
                                            "3查重",
                                            "uploadFile4",
                                            "applyForm"
                                          )
                                        },
                                      },
                                    }),
                                    _c("div", { staticClass: "tips" }, [
                                      _vm._v(
                                        "说明：PDF格式文件，文件名为：3查重学号姓名.pdf"
                                      ),
                                      _c("br"),
                                      _vm._v("例如：3查重012201161020张三.pdf"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "第三步",
                                  name: "3",
                                  disabled: true,
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "纸质资料递交方式",
                                      prop: "is_way",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.applyFormData.is_way,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.applyFormData,
                                              "is_way",
                                              $$v
                                            )
                                          },
                                          expression: "applyFormData.is_way",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [_vm._v("到校递交")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [_vm._v("邮件递交")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "", prop: "is_way" } },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "快递只能用顺丰快递（不要用顺丰同城）"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm.applyFormData.is_way == 0
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "到校地址" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "white-space": "break-spaces",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.arrivalAddress))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.applyFormData.is_way == 1
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "邮寄地址" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "white-space": "break-spaces",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.mailingAddress))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.applyFormData.is_way == 1
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "快递凭证",
                                          prop: "delivery_img",
                                        },
                                      },
                                      [
                                        _c("FalConUpload", {
                                          ref: "deliveryImg",
                                          attrs: {
                                            multiple: false,
                                            isShowModal: false,
                                          },
                                          on: {
                                            handleRemove:
                                              _vm.deliveryImgHandleRemove,
                                            handleChange:
                                              _vm.deliveryImgHandleChange,
                                          },
                                        }),
                                        _c("div", { staticClass: "tips" }, [
                                          _vm._v(
                                            "*按学校规定快递寄出后的快递单照片"
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "手写签名:",
                                      prop: "sign_img",
                                    },
                                  },
                                  [
                                    _c("esignHandle", {
                                      ref: "applyFormDataEsignHandle",
                                      attrs: {
                                        selectSignImg:
                                          _vm.applyFormData.sign_img,
                                      },
                                      on: {
                                        "update:selectSignImg": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.applyFormData,
                                            "sign_img",
                                            $event
                                          )
                                        },
                                        "update:select-sign-img": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.applyFormData,
                                            "sign_img",
                                            $event
                                          )
                                        },
                                        selectSignImgAfter: function ($event) {
                                          return _vm.studentSignImgAfter(
                                            $event,
                                            "applyForm",
                                            "sign_img"
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.isShowApplyFormPop = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _vm.activeNameNum < 3
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.nextClick },
                          },
                          [_vm._v("下一步")]
                        )
                      : _vm._e(),
                    _vm.activeNameNum > 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.previousStepClick },
                          },
                          [_vm._v("上一步")]
                        )
                      : _vm._e(),
                    _vm.activeNameNum == 3
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.applyFormPopSubmit },
                          },
                          [_vm._v("提交")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "el-dialog",
            {
              staticClass: "QA",
              attrs: {
                title: "查看问答",
                visible: _vm.isShowQAPop,
                width: "40%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isShowQAPop = $event
                },
                close: _vm.QAPopClose,
              },
            },
            [
              _c("div", { staticClass: "dialog" }, [
                _c(
                  "div",
                  _vm._l(_vm.QAData, function (item, index) {
                    return _c("div", { key: index }, [
                      _c("div", { staticClass: "item" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s("老师提问" + (index + 1)) + ":"),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.question)),
                        ]),
                      ]),
                      _c("div", { staticClass: "item" }, [
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s("学生回答" + (index + 1)) + ":"),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.answer)),
                        ]),
                      ]),
                    ])
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.isShowQAPop = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }